// extracted by mini-css-extract-plugin
export default {"container":"cha_1DAaF","title":"cha_tit_3Wuhg","description":"cha_des_3zo5t","isLoading":"cha_isL_3lA28","chart":"cha_cha_fcwxL"};